import { Component, Input, OnInit } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import moment from 'moment';
import printDoc from '../pdfExport/printDoc.js';

@Component({
  selector: 'app-export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.css']
})
export class ExportButtonComponent implements OnInit {

  @Input() private agGridReference: AgGridAngular;
  @Input() private title: string;
  @Input() private subTitle: string;
  @Input() private filename: string;
  @Input() private pageOritentation: string = 'portrait';
  @Input() private pivotMode: boolean = false;
  @Input() showPDF: boolean = true;
  @Input() showXLS: boolean = true;
  @Input() private rowBold: [];
  @Input() private rowPercentage: [];
  

  constructor() { }

  ngOnInit(): void {
  }

  onExportPdf() {
    const currentDate = moment().format('YYYY-MM-DD');
    const currentTime = moment().format('hh:mm:ss A');

    this.filename = (this.filename) ? this.filename : this.title;
    const printParams = {
      PDF_TITLE: this.title,
      PDF_SUB_TITLE: this.subTitle,
      PDF_GENERATED_ON: `Generated on ${currentDate} ${currentTime}`,
      PDF_HEADER_COLOR: "#f8f8f8",
      PDF_INNER_BORDER_COLOR: "#dde2eb",
      PDF_OUTER_BORDER_COLOR: "#babfc7",
      PDF_LOGO : "",
      PDF_PAGE_ORITENTATION: this.pageOritentation,
      PDF_WITH_HEADER_IMAGE: false,
      PDF_WITH_FOOTER_PAGE_COUNT: false,
      PDF_HEADER_HEIGHT: 10,
      PDF_ROW_HEIGHT: 10,
      PDF_ODD_BKG_COLOR: "#fcfcfc",
      PDF_EVEN_BKG_COLOR: "#ffffff",
      PDF_WITH_CELL_FORMATTING: true,
      PDF_WITH_COLUMNS_AS_LINKS: true,
      PDF_SELECTED_ROWS_ONLY: false,
      PDF_FILENAME: this.filename.replace(/\s/g,'') + "_" + currentDate,
      PDF_PIVOT_MODE: this.pivotMode,
      PDF_ROW_BOLD: this.rowBold,
      PDF_ROW_PERCENTAGE: this.rowPercentage
    };
    printDoc(printParams, this.agGridReference.api, this.agGridReference.columnApi);
  }

  onExportXls() {
    this.agGridReference.api.exportDataAsExcel();
  }

}
